import { XCircleIcon, CheckCircleIcon } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'

interface Toast {
  id: string
  message: string
  type: 'error' | 'success'
}

let toastId = 0
const toastListeners = new Set<(toasts: Toast[]) => void>()
let toasts: Toast[] = []

function notify() {
  toastListeners.forEach(listener => listener([...toasts]))
}

export function showToast(message: string, type: 'error' | 'success' = 'error') {
  const id = `toast-${toastId++}`
  toasts = [...toasts, { id, message, type }]
  notify()

  setTimeout(() => {
    toasts = toasts.filter(t => t.id !== id)
    notify()
  }, 5000)
}

export function ToastContainer() {
  const [currentToasts, setCurrentToasts] = useState<Toast[]>([])

  useEffect(() => {
    const listener = (newToasts: Toast[]) => {
      setCurrentToasts(newToasts)
    }
    toastListeners.add(listener)
    setCurrentToasts([...toasts])

    return () => {
      toastListeners.delete(listener)
    }
  }, [])

  if (currentToasts.length === 0) return null

  return (
    <div className="fixed top-20 right-5 z-[10000] flex flex-col gap-2">
      {currentToasts.map(toast => (
        <div
          key={toast.id}
          className={`px-4 py-3 rounded-md shadow-lg flex items-center gap-2 min-w-[300px] max-w-[500px] ${
            toast.type === 'error'
              ? 'bg-red-500 text-white'
              : 'bg-green-500 text-white'
          }`}
        >
          {toast.type === 'error' ? (
            <XCircleIcon weight="fill" size={20} />
          ) : (
            <CheckCircleIcon weight="fill" size={20} />
          )}
          <span className="flex-1 text-sm">{toast.message}</span>
        </div>
      ))}
    </div>
  )
}

